import { memo } from "react";
import { Division, TabList } from "@ir/ui";
import CreditInformationTab from "./InformationTab";

const CreditTabList = () => {
  return (
    <Division>
      <TabList className="shadow-all-none" aria-label="Credits Drawer Tabs Panel">
        <CreditInformationTab />
      </TabList>
    </Division>
  );
};

export default memo(CreditTabList);
